<template>
    <div class="
        flex w:full ai:center p:16 gap:8 box-shadow:0|0|20|0|#0000001A r:20 actived bg:white
        {flex-direction:column;ai:stretch;gap:8}.actived
        {flex}.actived_.username>div:nth-child(2)
        {flex}.actived_.buttons
        {block}.actived_.attachments
    " v-if="toggler(signEdit).isOpen()">
        <topic-comment-field @cancel="toggler(signEdit).close()" @chuser="chuser" :data="item" @update="save"></topic-comment-field>
    </div>
    <template v-else-if="item.content">
        <div class="flex ai:center">
            <div class="mr:8" v-if="item.top">
                <img alt="" src="image/icon_pin.svg" />
            </div>
            <member-avatar :icon-url="item.avatar_url" :short-name="item.short_name" :type="item.nickname_type"></member-avatar>
            <div class="flex:1 ml:8">
                <div class="f:14 lh:1.4285 color:#333 font:bold inline-flex gap:12 ai:center">
                    {{ item.nickname }}
                    <span class="bg:#FFE8EB f:12 p:4|8 r:8 font:regular" v-if="isSelf">你的留言</span>
                </div>
                <div class="f:12 lh:1.3333 color:#6F737D">{{ item.publish_time }}</div>
            </div>
            <div class="ml:12" v-if="isSelf && !readonly && !disabled">
                <button class="inline-flex w:18 h:18 ai:center jc:center rel color:primary" @click.stop="toggler(signEdit).open()" type="button">
                    <i class="fa-solid fa-pen"></i>
                </button>
            </div>
            <div class="ml:12" v-if="!readonly && !disabled">
                <div class="inline-block rel" @click.stop>
                    <div class="abs r:20 bg:white box-shadow:0|0|20|0|#0000001A bottom:50% right:100% mr:10 mb:0 translateY(75%) z:1" v-if="toggler(signCommentMenu).isOpen()">
                        <div class="
                            rel p:16 r:20
                            {content:'';abs;bg:url(image/arrow_tooltip.svg);bottom:75%;right:-6;w:12;h:6;mb:-6;mr:0;transform-origin:50%|0;rotate(-90deg)}::after
                            {w:100;b:0;p:8|16;inline-flex;ai:center;gap:8;white-space:nowrap}>button
                            {r:12;bg:#F8F8F8}>button:hover
                        ">
                            <template v-if="isOwner">
                                <button @click="setTop(false)" type="button" v-if="item.top">取消置頂</button>
                                <button @click="setTop(true)" type="button" v-else>置頂留言</button>
                            </template>
                            <button @click="doDelete" type="button" v-if="isSelf || isOwner">刪除留言</button>
                            <button @click="doInform" type="button" v-else>檢舉</button>
                        </div>
                    </div>
                    <button class="inline-flex w:18 h:18 ai:center jc:center" @click="toggler(signCommentMenu).toggle(true)" type="button">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="my:12 f:16 font:normal lh:1.5 color:#333 word-break:break-all pl:36 rel {content:'';abs;h:full;w:1;bg:#CECECE;left:16;top:0}::before">
            <topic-content collapsible comment :modified="item.modify_time" :to="item.to" v-model="item.content"></topic-content>
        </div>
        <div class="flex ai:center jc:space-between">
            <div class="flex gap:8 f:14">
                <div>{{ item.floor }}</div>
                <div class="post-func-buttons">
                    <topic-like-buttons
                        :college-id="collegeId"
                        :comment-id="item.id"
                        :dislike="item.dislike"
                        :dislike-count="item.dislike_count"
                        :like="item.like"
                        :like-count="item.like_count"
                        :observe="item.observe"
                        :observe-count="item.observe_count"
                        :readonly="readonly"
                        :topic-id="item.topic_id"
                    ></topic-like-buttons>
                    <button @click="emit('toggle')" :disabled="readonly" v-if="!parent" type="button">
                        <i class="icon bg:url(image/part/icon_comment.svg)"></i><span>{{ item.reply_count }}</span>
                    </button>
                </div>
            </div>
            <div v-if="!readonly && !disabled">
                <button class="b:0 p:8|12 font:bold f:14 bg:white r:8" @click="emit('reply')" type="button">回覆</button>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="my:12 f:16 font:normal lh:1.5 color:#A9A9A9">此則留言已被刪除。</div>
        <div class="flex ai:center jc:space-between">
            <div class="flex gap:8 f:14">
                <div>{{ item.floor }}</div>
            </div>
        </div>
    </template>
</template>

<script setup>
    const toggleStore = new ToggleStore();
    const userInfo = useUserInfo();

    const signCommentMenu = Symbol('_menu_comment');
    const signEdit = Symbol('editMode');

    const props = defineProps({
        collegeId: { type: Number },
        disabled: { default: false, type: Boolean },
        item: { required: true, type: Object },
        parent: { type: Object },
        partId: { required: true, type: Number },
        readonly: { default: false, type: Boolean }
    });

    const isSelf = computed(() => props.item.member_id === userInfo.id);
    const isOwner = computed(() => userInfo.parts?.includes(props.partId));

    const chuser = (currentType) => {
        emit("chuser", currentType);
    };

    const emit = defineEmits(["chuser", "delete", "inform", "reply", "toggle"]);

    const doDelete = () => {
        emit("delete");
        toggler(signCommentMenu).toggle();
    };

    const doInform = () => {
        emit("inform");
        toggler(signCommentMenu).toggle();
    };

    const save = (data) => {
        data.comment_id = props.item.id;

        api("api/topic/comment/save", data).done((res) => {
            if (res.success) {
                Object.assign(props.item, res.data);

                toggler(signEdit).close();
            }
        });
    }

    const setTop = (top) => {
        api("api/topic/comment/top", { comment_id: props.item.id, top }).done((res) => {
            if (res.success) {
                props.item.top = res.top;
                toggler(signCommentMenu).toggle();
            }
        });
    };

    const toggler = (name) => {
        return toggleStore.toggler(name);
    };
</script>
